import React, { Fragment } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import kebabCase from 'lodash/kebabCase'
import { getOnClickAndOnKeyPressDownEvents } from 'helpers/getOnClickAndOnKeyPressDownEvents'
import Mixin from 'components/common/Mixin'
import Media from 'components/common/Media'
import model from '../viewModel'
import { SERVICES_SELECTOR_TARGET_ID } from 'constant'
import Section from '../Section'
import ServiceCategory from '../ServiceCategory'
import { TabPanel } from 'components/common/Tabs/Tabs.styles'
import { Field } from 'redux-form'
import ServicesBlock from '../ServicesBlock'
import { LOOKING_FOR_TIRE_PRICES_CATEGORY } from '../constants'

const BOTServicesSelector = ({
  icon,
  question,
  title,
  chosenHandler,
  chosenIndex,
  servicesPickerItems,
  position,
  menu,
  onClick,
  onKeyDown,
  setFocusScopeRef
}) =>
  <Fragment>
    <Section
      asset={ icon }
      title={ title }
      subhead={ question }
      targetId={ SERVICES_SELECTOR_TARGET_ID }>
      <Media.Desktop>
        <ServiceWrapper aria-label="tab list" role="tablist" ref={ setFocusScopeRef }>
          {
            menu.map(({ categoryName, checked, iconName }, index) =>
              <ServiceCategory
                data-cta
                key={ index }
                id={ `${kebabCase(categoryName)}-tab-item-${index}` }
                role="tab"
                aria-controls={ `${kebabCase(categoryName)}-tab-panel-${index}` }
                aria-selected={ position === index }
                tabIndex={ position === index ? null : -1 }
                title={ categoryName }
                checked={ checked }
                condition={ position === index }
                iconName={ iconName }
                index={ index }
                chosenIndex={ position }
                categoryServices={ servicesPickerItems[index] }
                onClick={ onClick }
                onKeyDown={ onKeyDown } />
            )
          }
        </ServiceWrapper>
        {
          menu.map(({ categoryName }, index) =>
            <TabPanel
              key={ index }
              role="tabpanel"
              id={ `${kebabCase(categoryName)}-tab-panel-${index}` }
              tabIndex="0"
              aria-labelledby={ `${kebabCase(categoryName)}-tab-item-${index}` }
              active={ position === index }>
              <Field
                { ...model.servicesSelector }
                component={ ServicesBlock }
                defaultData={ servicesPickerItems[index] }
                title={ categoryName }
                showLookingForTirePrices={ categoryName === LOOKING_FOR_TIRE_PRICES_CATEGORY } />
            </TabPanel>
          )
        }
      </Media.Desktop>
      <Media.Mobile>
        <ServiceWrapper>
          {
            menu.map(({ categoryName, checked, iconName }, index) =>
              <ServiceCategory
                data-cta
                key={ index }
                aria-expanded={ chosenIndex === index }
                aria-controls={ `${kebabCase(categoryName)}-region-${index}` }
                aria-disabled={ chosenIndex === index || null }
                id={ `${kebabCase(categoryName)}-accordion-${index}` }
                title={ categoryName }
                checked={ checked }
                condition={ chosenIndex === index }
                iconName={ iconName }
                index={ index }
                chosenIndex={ chosenIndex }
                categoryServices={ servicesPickerItems[index] }
                { ...getOnClickAndOnKeyPressDownEvents(() => chosenHandler(index)) } />
            )
          }
        </ServiceWrapper>
      </Media.Mobile>
    </Section>
  </Fragment>


export default BOTServicesSelector

BOTServicesSelector.propTypes = {
  chosenHandler: PropTypes.func,
  chosenIndex: PropTypes.number,
  icon: PropTypes.string,
  menu: PropTypes.arrayOf(PropTypes.shape()),
  onClick: PropTypes.func,
  onKeyDown: PropTypes.func,
  position: PropTypes.number,
  question: PropTypes.string,
  servicesPickerItems: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.shape())),
  setFocusScopeRef: PropTypes.func,
  title: PropTypes.string
}

const ServiceWrapper = styled.div`
  position: relative;
  text-align: center;
  ${Mixin.responsive('padding', '25px 0 0', '0')}
`
